<template>
  <div>
    <div v-if="isAgent() || isAdmin()">
      <agent-us-returned-goods-custody/>
    </div>
    <div v-if="isSeller()">
      <seller-us-returned-goods-custody/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import AgentUsReturnedGoodsCustody from '@/components/return-and-storage/agent/UsReturnedGoodsCustody';
import SellerUsReturnedGoodsCustody from '@/components/return-and-storage/seller/UsReturnedGoodsCustody';

export default {
  mixins: [BaseView],
  created() { this.updateTitle(this.$i18n.t('returnedAndStorage.title')); },
};

Vue.component('agent-us-returned-goods-custody', AgentUsReturnedGoodsCustody);
Vue.component('seller-us-returned-goods-custody', SellerUsReturnedGoodsCustody);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
